var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeightMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "weight_map") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "weight_map"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.908203 10.6881C0.908203 10.1546 2.37954 4.64155 2.44642 4.40443C2.5133 4.16731 2.84769 3.98947 3.04833 3.98947H3.91776V1.6372C3.91776 1.40008 4.18527 0.925837 4.65343 0.866557C4.99434 0.823388 6.11552 0.843092 6.90638 0.856991C7.20154 0.862178 7.45069 0.866557 7.5961 0.866557C8.13113 0.866557 8.33177 1.28151 8.33177 1.51863V3.98947H9.33496C9.66935 3.98947 9.86999 4.28588 9.93687 4.40443C10.0037 4.52299 11.4082 10.2732 11.4082 10.6881C11.4082 11.1031 11.2076 11.3402 10.7394 11.3402H1.57699C1.30948 11.3402 0.908203 11.0438 0.908203 10.6881ZM5.0107 3.98946L7.32205 3.98947V2.07327C7.32205 1.89543 7.24692 1.77687 6.97314 1.77687H5.3451C5.07758 1.77687 4.94382 1.89543 4.94382 2.07327V3.98946H5.0107Z",
    fill: "#4D4D4D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightMap);
export default __webpack_public_path__ + "static/media/weight_map.a2765aaa5a34bdc5804588fb091cd755.svg";
export { ForwardRef as ReactComponent };